import { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useApplicationContext } from '../../../../Helpers/Contexts/applicationContext';
import { getScopeKeys, hasEnableRule, hasShowRule, isEnabled, isVisible } from '../../ruleHelper';
import KenWidget from '../KenWidget';

function KenFieldContent(props) {
  const { rule, metaData, options } = props;
  const { getValues, watch, unregister } = useFormContext();
  const disabledProps = hasEnableRule(props) ? { disabled: !isEnabled(props.rule, {}, getValues) } : {};

  const [extras, setExtras] = useState({});
  const {
    applicationState: { formOptions = {} },
  } = useApplicationContext();

  const watchFields = watch(getScopeKeys(rule));
  const ruleValues = useMemo(() => getRuleVaues(watchFields, rule, getValues), [watchFields, rule]);

  useEffect(() => {
    if (metaData?.optionsKey) {
      const addedOptions = formOptions[metaData?.optionsKey] || [];
      setExtras({
        options: [...options, ...addedOptions],
        extraProps: true,
      });
    }
  }, [metaData, options, formOptions]);

  useEffect(() => {
    if (ruleValues?.isVisible === false) {
      unregister(props?.name);
    }
  }, [ruleValues?.isVisible === false]);

  return <>{hasShowRule(props) ? ruleValues.isVisible && <KenWidget {...props} {...extras}></KenWidget> : <KenWidget {...props} {...disabledProps} {...extras}></KenWidget>}</>;
}

const getRuleVaues = function (watchFields, rule, getValues) {
  if (rule && getScopeKeys(rule)?.length > 0) {
    return {
      isVisible: isVisible(rule, {}, getValues),
    };
  }

  return {};
};

export default KenFieldContent;
